var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router } from '@angular/router';
import { Payee, PayeeWebChecklist } from '../../shared/sdk/models';
import { PayeeApi, PayeeDetailApi, StorageApi } from '../../shared/sdk/services';
import { FormPage } from '../../shared/app/classes/form-page';
import { GlobalEventsManager } from '../../events-manager.component';
import { SubmissionDetailService } from "../../shared/app/services/";
import { Validation } from '../../shared/app/services/validation';
var ɵ0 = window;
var UpdateBizAccComponent = /** @class */ (function (_super) {
    __extends(UpdateBizAccComponent, _super);
    function UpdateBizAccComponent(userApi, payeeDetailApi, storageApi, eventsManager, router, submissionDetailService, validation, document) {
        var _this = _super.call(this, new PayeeWebChecklist(), userApi, storageApi, eventsManager) || this;
        _this.router = router;
        _this.submissionDetailService = submissionDetailService;
        _this.validation = validation;
        _this.document = document;
        _this.m2upayShow = false;
        _this.payeeDetailApi = payeeDetailApi;
        _this.eventsManager.loaded(false);
        return _this;
    }
    // Initialisation
    UpdateBizAccComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var script;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.populateFormData()];
                    case 1:
                        _a.sent();
                        script = document.createElement('script');
                        script.type = 'text/javascript';
                        script.src = 'js/script.js';
                        script.onload = function () {
                            console.log('SCRIPT LOAD');
                        };
                        script.onerror = function () { return console.log('SCRIPT ERROR'); };
                        document.getElementsByTagName('head')[0].appendChild(script);
                        return [2 /*return*/];
                }
            });
        });
    };
    UpdateBizAccComponent.prototype.populateFormData = function () {
        var _this = this;
        this.userApi.findById(this.userApi.getCurrentId(), { include: ["details", "m2uPayAccountDetails"] }).subscribe(function (payee) {
            console.log(payee);
            if (payee.details && payee.details.business_account_no == null) {
                // console.log(payee.m2uPayAccountDetails['account_number_collection'])
                // console.log(payee.m2uPayAccountDetails['account_number_charging'])
                if (payee["m2uPayAccountDetails"]) {
                    if (payee.m2uPayAccountDetails && payee.m2uPayAccountDetails['account_number_collection'] == null && payee.m2uPayAccountDetails['account_number_charging'] == null) {
                        _this.m2upayShow = true;
                    }
                }
                _this.eventsManager.loaded(true);
            }
            else {
                // this.eventsManager.showPopUp("You have already filled in your Maybank Current Account No.");
                // this.router.navigate(['/dashboard']);
                _this.eventsManager.loaded(true);
            }
        }, function (err) {
            console.log(err);
            _this.eventsManager.logout(true);
            // this.router.navigate(['/dashboard']);
            _this.eventsManager.showPopUp("Your session has expired. Please login.");
            _this.eventsManager.loaded(true);
        });
    };
    UpdateBizAccComponent.prototype.addEventListeners = function () { };
    // Validation
    UpdateBizAccComponent.prototype.validate = function () {
        this.clrSubmit.nativeElement.click();
        this.valid = true;
        this.valid = this.business_account_no && this.valid;
        // console.log(this.valid)
        if (this.m2upayShow) {
            console.log(this.valid);
            this.valid = this.account_number_collection && this.account_number_charging && this.valid;
        }
        console.log(this.valid);
        // console.log(this.valid)
        var elements = this.document.getElementsByName('biz-acc-form')[0].getElementsByClassName('error');
        console.log({ elements: elements });
        for (var i = 0; i < elements.length; i++) {
            console.log(i);
            console.log(elements[i].parentElement.parentElement.getAttribute('hidden'));
            console.log(elements[i].parentElement.getAttribute('hidden'));
            if (elements[i].parentElement.parentElement.getAttribute('hidden') == null &&
                elements[i].parentElement.getAttribute('hidden') == null) {
                this.valid = elements.length <= 0 && this.valid;
            }
        }
        console.log(this.valid);
        // this.valid = elements.length == 0 && this.valid;
        console.log(this.valid);
        return this.valid;
    };
    // Save form page
    UpdateBizAccComponent.prototype.save = function (submit) {
        // Send to temp storage
        var that = this;
        return [];
    };
    UpdateBizAccComponent.prototype.submit = function (submit) {
        var _this = this;
        var that = this;
        if (!this.validate() && submit) {
            that.eventsManager.showPopUp("Please fill in and ensure all the fields are valid.");
        }
        else {
            var details_1 = {
                business_account_no: this.business_account_no,
                account_number_collection: this.account_number_collection,
                account_number_charging: this.account_number_charging
            };
            // Send to temp storage
            var promises = [];
            var p = new Promise(function (resolve, reject) {
                that.payeeDetailApi.updateBusinessAccount(that.userApi.getCurrentId(), details_1).subscribe(function (updatedPayeeDetails) {
                    if (updatedPayeeDetails) {
                        resolve(updatedPayeeDetails);
                    }
                    else {
                        that.eventsManager.failedSavePopUp();
                    }
                }, function (err) {
                    reject(err);
                });
            });
            p.then(function (res) {
                _this.eventsManager.showPopUp("Maybank Current Account submitted successfully.");
                that.router.navigate(['/dashboard']);
            })
                .catch(function (err) {
                console.log("updateDetails err");
                console.log({ err: err });
                that.eventsManager.showPopUp("Failed to submit new Maybank Current Account No.");
            });
        }
    };
    // Scrolling
    UpdateBizAccComponent.prototype.scrollToTop = function () {
        window.scroll(0, 0);
        document.body.getElementsByClassName('scroll_checklist')[0].scrollTop = 0;
    };
    UpdateBizAccComponent.prototype.scrollToSave = function () {
        //document.body.getElementsByClassName('scroll_checklist')[0].scrollTop = document.getElementById('save_checklist').offsetTop;
    };
    UpdateBizAccComponent.prototype.updateDocStatus = function () { };
    UpdateBizAccComponent.prototype.validateDocs = function () { };
    // Before submit, clean up backend data
    UpdateBizAccComponent.prototype.cleanUpData = function () {
        return [];
    };
    return UpdateBizAccComponent;
}(FormPage));
export { UpdateBizAccComponent };
export { ɵ0 };
